import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Avatar,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Tooltip,
  Divider,
  Button
} from "@mui/material";

// App Icons
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InventoryIcon from '@mui/icons-material/Inventory';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import TextureIcon from '@mui/icons-material/Texture';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ChatIcon from '@mui/icons-material/Chat';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ToysIcon from '@material-ui/icons/Toys';
import TimelineIcon from '@material-ui/icons/Timeline';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import ViewHeadlineRoundedIcon from '@material-ui/icons/ViewHeadlineRounded';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import DeblurIcon from '@mui/icons-material/Deblur';
import GroupIcon from '@mui/icons-material/Group';
import InventoryTwoToneIcon from '@mui/icons-material/InventoryTwoTone';
import ArticleIcon from '@mui/icons-material/Article';
import NoteIcon from '@mui/icons-material/Note';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BalanceIcon from '@mui/icons-material/Balance';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BusinessIcon from '@mui/icons-material/Business';
import PaymentsIcon from '@mui/icons-material/Payments';
import { Settings } from "@mui/icons-material";

//---------------- Styles---------------- 
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Sidebar + Logout---------------- 
import Sidebar from "./Sidebar";
import Logout from "./Logout";

//---------------- Styles---------------- 
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//-----------SessionTimeOut---------
//import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";

//-----------Master-----------------
import MasterIndex from "./components/pages/Master/Index";
import AccountHeadEdit from "./components/pages/Master/AHDEdit";
import BKEdit from "./components/pages/Master/BankEdit";
import StaffEdit from "./components/pages/Master/StaffEdit";
import AssetEdit from "./components/pages/Master/AssetEdit";
import COSEdit from "./components/pages/Master/CSEdit";
import otherEdit from "./components/pages/Master/OtherEdit";
import CapitalEdit from "./components/pages/Master/CapitalEdit";

//-----------Balance Sheet----------
import BalanceSheetIndex from "./components/pages/BalanceSheet/Index";

//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------Item------------------- 
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemIndex from "./components/pages/Item/Index";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//----------Category----------------
import CategoryCreate from "./components/pages/Category/Create";
import CategoryEdit from "./components/pages/Category/Edit";
import CategoryIndex from "./components/pages/Category/Index";

//----------Purchase----------------
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";

//----------Purchase Order----------
import PurchaseOrderIndex from "./components/pages/PurchaseOrder/Index";
import PurchaseOrderCreate from "./components/pages/PurchaseOrder/Create";
import PurchaseOrderEdit from "./components/pages/PurchaseOrder/Edit";
import PurchaseOrderDetails from "./components/pages/PurchaseOrder/Details";

//----------Sale--------------------
import SaleIndex from "./components/pages/Sale/Index";
import SaleCreate from "./components/pages/Sale/Create";
import SaleEdit from "./components/pages/Sale/Edit";
import SaleDetails from "./components/pages/Sale/Details";

//----------JournalEntry-------------
import JournelEntry from "./components/pages/JournalEntryPage/Create";
import JournelEntryIndex from "./components/pages/JournalEntryPage/Index";
import JournalEntryEdit from "./components/pages/JournalEntryPage/Edit";
import JournalEntryDetails from "./components/pages/JournalEntryPage/Details";

//----------Receipt------------------
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptDetails from "./components/pages/Receipt/Details";
import ReceiptEdit from "./components/pages/Receipt/Edit";

//----------Payment------------------
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentDetails from "./components/pages/Payment/Details";
import PaymentEdit from "./components/pages/Payment/Edit";

//----------stock Journal------------
import StockJournalIndex from "./components/pages/StockJournal/Index";
import StockJournalCreate from "./components/pages/StockJournal/Create";
import StockJournalDetails from "./components/pages/StockJournal/Details";
import StockJournalEdit from "./components/pages/StockJournal/Edit";

//----------Purchase Return----------
import PurchaseReturnIndex from "./components/pages/PurchaseReturn/Index";
import PurchaseReturnCreate from "./components/pages/PurchaseReturn/Create";
import PurchaseReturnEdit from "./components/pages/PurchaseReturn/Edit";
import PurchaseReturnDetails from "./components/pages/PurchaseReturn/Details";

//----------Reports------------------
import CreditorDebitorReport from "./components/pages/Report/CreditorDebitor";
import CustomerOutstandingReport from "./components/pages/Report/CustomerOutstanding";
import SupplierOutstandingReport from "./components/pages/Report/SupplierOutstanding";
import StockItemReport from "./components/pages/Report/StockItem";
import StockRawMaterialReport from "./components/pages/Report/StockRawMaterial";
import Ledger from "./components/pages/Report/Ledger";
import SaleRegister from "./components/pages/Report/SaleRegister";
import PurchaseRegisterReport from "./components/pages/Report/PurchaseRegister";
import CashBook from "./components/pages/Report/CashBook";
import Salegstreport from "./components/pages/Report/SaleGstReport";
import SaleHSNCReport from "./components/pages/Report/SaleHSNC";
import Stock from "./components/pages/Report/Stock";
import TrialBalanceReport from "./components/pages/Report/TrialBalance";
import DailySaleProfitReport from "./components/pages/Report/DailySaleProfit";
import SaleAnalysisReport from "./components/pages/Report/SaleAnalysis";
import PartyandItemWiseReport from "./components/pages/Report/party&ItemWise";
import PurchasePartyandItemWiseReport from "./components/pages/Report/PuchaseParty&ItemWise";
import SalePaymentWise from "./components/pages/Report/SalePaymentWise";

//-----------Sale Return----------------
import SaleReturnIndex from "./components/pages/SaleReturn/Index";
import SaleReturnCreate from "./components/pages/SaleReturn/Create";
import SaleReturnEdit from "./components/pages/SaleReturn/Edit";
import SaleReturnDetails from "./components/pages/SaleReturn/Details";

//----------Income Or Expense-----------
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";

//----------Payment and Receipt----------
import PaymentAndReceiptIndex from "./components/pages/PaymentAndReceipt/Index";
import PaymentAndReceiptCreate from "./components/pages/PaymentAndReceipt/Create";
import PaymentAndReceiptDetails from "./components/pages/PaymentAndReceipt/Details";
import PaymentAndReceiptEdit from "./components/pages/PaymentAndReceipt/Edit";
//----------------- Proforma  ----------------
import ProformaIndex from "./components/pages/Proforma/Index";
import ProformaCreate from "./components/pages/Proforma/Create";
import ProformaEdit from "./components/pages/Proforma/Edit";
import ProformaDetails from "./components/pages/Proforma/Details";

// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: "#34332f" },
    secondary: { main: "#34332f" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hoverOpen, setHoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { companyName, roleName, username } = useAuth();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Header */}
        <AppBar position="fixed" color="primary" sx={{ zIndex: 1300 }} style={{ height: '55px' }}>
          <Toolbar>
            <IconButton color="inherit" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              sx={{ flexGrow: 1, ml: 2, fontWeight: "bold", textTransform: "uppercase" }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
              </Link>
            </Typography>

            <div className="white-icon" style={{ display: 'flex', alignItems: 'center', marginTop: '-5px', }} >
              <div style={{ display: 'flex', alignItems: 'center', }} >
                <Logout />
              </div>
            </div>
          </Toolbar>
        </AppBar>

        {/* Sidebar */}
        {username !== "Counter" && (
          <Box
            onMouseEnter={() => setHoverOpen(true)}
            onMouseLeave={() => setHoverOpen(false)}
          >
            <Sidebar open={sidebarOpen || hoverOpen} roleName={roleName} />
          </Box>
        )}

        {/* Content */}
        <Box
          sx={{
            ml: username !== "Counter" ? (sidebarOpen || hoverOpen ? "240px" : "60px") : "0px",
            pt: 8,
            transition: "margin-left 0.3s ease",
            minHeight: "100vh",
            backgroundColor: "#f5f5f5"
          }}
        >
          <Container maxWidth={false} sx={{ mt: 1, px: 2, width: "100%" }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Item */}
              <Route path="/ItemIndex" component={ItemIndex} />
              <Route path="/ItemCreate" component={ItemCreate} />
              <Route path="/ItemEdit/:id" component={ItemEdit} />

              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />

              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />

              {/* Category */}
              <Route path="/CategoryIndex" component={CategoryIndex} />
              <Route path="/CategoryCreate" component={CategoryCreate} />
              <Route path="/CategoryEdit/:id" component={CategoryEdit} />

              {/* Master  */}
              <Route path="/MasterIndex" component={MasterIndex} />
              <Route path="/AccountHeadEdit/:id/:Mtypeid" component={AccountHeadEdit} />
              <Route path="/AssetEdit/:id/:Mtypeid" component={AssetEdit} />
              <Route path="/BKEdit/:id/:Mtypeid" component={BKEdit} />
              <Route path="/StaffEdit/:id/:Mtypeid" component={StaffEdit} />
              <Route path="/CapitalEdit/:id/:mid" component={CapitalEdit} />
              <Route path="/COSEdit/:id/:Mtypeid" component={COSEdit} />

              {/* BalanceSheet  */}
              <Route path="/BalanceSheetIndex" component={BalanceSheetIndex} />

              {/* Purchase */}
              <Route path="/PurchaseIndex" component={PurchaseIndex} />
              <Route path="/PurchaseCreate" component={PurchaseCreate} />
              <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
              <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />

              {/* Purchase Order */}
              <Route path="/PurchaseOrderIndex" component={PurchaseOrderIndex} />
              <Route path="/PurchaseOrderCreate" component={PurchaseOrderCreate} />
              <Route path="/PurchaseOrderEdit/:id" component={PurchaseOrderEdit} />
              <Route path="/PurchaseOrderDetails/:id" component={PurchaseOrderDetails} />
              
              {/* Sale */}
              <Route path="/SaleIndex" component={SaleIndex} />
              <Route path="/SaleCreate" component={SaleCreate} />
              <Route path="/SaleEdit/:id" component={SaleEdit} />
              <Route path="/SaleDetails/:id" component={SaleDetails} />

              {/* Logout */}
              {/* <Route path="/Logout" component={Logout} /> */}

              {/* JournalEntry */}
              <Route path="/JournelEntry" component={JournelEntry} />
              <Route path="/JournelEntryIndex" component={JournelEntryIndex} />
              <Route path="/JournalEntryEdit/:id" component={JournalEntryEdit} />
              <Route path="/JournalEntryDetails/:id" component={JournalEntryDetails} />
             
              {/* Receipt */}
              <Route path="/ReceiptIndex" component={ReceiptIndex} />
              <Route path="/ReceiptCreate" component={ReceiptCreate} />
              <Route path="/ReceiptDetails/:id" component={ReceiptDetails} />
              <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />
             
              {/* Payment */}
              <Route path="/PaymentIndex" component={PaymentIndex} />
              <Route path="/PaymentCreate" component={PaymentCreate} />
              <Route path="/PaymentDetails/:id" component={PaymentDetails} />
              <Route path="/PaymentEdit/:id" component={PaymentEdit} />

              {/* Purchase Return */}
              <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
              <Route path="/PurchaseReturnCreate/:id" component={PurchaseReturnCreate} />
              <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />
              <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />

              {/* Report */}
              <Route path="/CreditorDebitorReport" component={CreditorDebitorReport} />
              <Route path="/CustomerOutstandingReport" component={CustomerOutstandingReport} />
              <Route path="/SupplierOutstandingReport" component={SupplierOutstandingReport} />
              <Route path="/StockItemReport" component={StockItemReport} />
              <Route path="/StockRawMaterialReport" component={StockRawMaterialReport} />
              <Route path="/Ledger" component={Ledger} />
              <Route path="/PurchaseRegisterReport" component={PurchaseRegisterReport} />
              <Route path="/SaleRegister" component={SaleRegister} />
              <Route path="/CashBook" component={CashBook} />
              <Route path="/Salegstreport" component={Salegstreport} />
              <Route path="/SaleHSNCReport" component={SaleHSNCReport} />
              <Route path="/Stock" component={Stock} />
              <Route path="/TrialBalanceReport" component={TrialBalanceReport} />
              <Route path="/DailySaleProfitReport" component={DailySaleProfitReport} />
              <Route path="/SaleAnalysisReport" component={SaleAnalysisReport} />
              <Route path="/PartyandItemWiseReport" component={PartyandItemWiseReport} />
              <Route path="/PurchasePartyandItemWiseReport" component={PurchasePartyandItemWiseReport} />
              <Route path="/SalePaymentWise" component={SalePaymentWise} />

              {/* StockJournal */}
              <Route path="/StockJournalIndex" component={StockJournalIndex} />
              <Route path="/StockJournalCreate" component={StockJournalCreate} />
              <Route path="/StockJournalDetails/:id" component={StockJournalDetails} />
              <Route path="/StockJournalEdit/:id" component={StockJournalEdit} />

              {/* Sale Return */}
              <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
              <Route path="/SaleReturnCreate/:id" component={SaleReturnCreate} />
              <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
              <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />

              {/* Income Or Expense */}
              <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
              <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
              <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
              <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />

              {/* Payment And Receipt */}
              <Route path="/PaymentAndReceiptIndex" component={PaymentAndReceiptIndex} />
              <Route path="/PaymentAndReceiptCreate" component={PaymentAndReceiptCreate} />
              <Route path="/PaymentAndReceiptDetails/:id" component={PaymentAndReceiptDetails} />
              <Route path="/PaymentAndReceiptEdit/:id" component={PaymentAndReceiptEdit} />
              {/*----------------- Proforma  ----------------*/}
              <Route path="/ProformaIndex" component={ProformaIndex} />
              <Route path="/ProformaCreate" component={ProformaCreate} />
              <Route path="/ProformaEdit/:id" component={ProformaEdit} />
              <Route path="/ProformaDetails/:id" component={ProformaDetails} />

              {/* Payment And Receipt */}
              <Route path="/CompanyEdit" component={CompanyEdit} />
            </Switch>
          </Container>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
